/**
 * Standard kicker + h1 header used at the top of every super-admin page
 * (Batch 27e Lane 9 #7; dark-mode pass added in 27f).
 */
interface Props {
  title: string;
  kicker?: string;
}

export function PageHeader({ title, kicker = "Super Admin" }: Props): JSX.Element {
  return (
    <div>
      <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-text-secondary dark:text-brand-100/50">
        {kicker}
      </p>
      <h1 className="text-2xl font-bold tracking-tight text-brand-900 dark:text-text-primary">
        {title}
      </h1>
    </div>
  );
}
